module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/result01_sp-0a7157565dcf9801ab975e1c06fa5165.png";